import { EnvProvider } from '@zenbusiness/application-commons-env';
import PropTypes from 'prop-types';

import ClickstreamWrapper from '#client/ClickstreamWrapper';
import { BankingWidgetV2 } from '#client/components/BankingWidget';
import AppWrapper from '#client/Providers';

const ENV = process.env.BUILD_ENV;

function FederatedBankingWidgetV2({ widgetId }) {
  return (
    <EnvProvider env={ENV}>
      <EnvProvider env={`${ENV.DEFAULT_SEGMENT}/env?v=${ENV.RELEASE_VERSION}`}>
        <AppWrapper federated>
          <ClickstreamWrapper>
            <BankingWidgetV2 widgetId={widgetId} />
          </ClickstreamWrapper>
        </AppWrapper>
      </EnvProvider>
    </EnvProvider>
  );
}

FederatedBankingWidgetV2.propTypes = {
  /** Widget ID */
  widgetId: PropTypes.string.isRequired
};

export default FederatedBankingWidgetV2;
